import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ActionConfirmComponent } from '../../../../components/ui/actionconfirm/actionconfirm.component';
import { FloatingItem } from '../../../../components/ui/floatingbar/floatingbar-item';
import { PageTemplateTable } from '../../../../directives/page-template-table/page-template-table';
import { ActionConfirmModel } from '../../../../models/action-confirm.model';
import { StoreAccessoryRequestSearch } from '../../../../models/api-store/store-accessory/store-accessory.request.model';
import { StoreAccessoryResponsePublish, StoreAccessoryResponseUpdate } from '../../../../models/api-store/store-accessory/store-accessory.response.model';
import { StoreAccessoryService } from '../../../../services/api-store/store-accessory/store-accessory.service';
import { AccessoristoreCreateComponent } from './accessoristore-create/accessoristore-create.component';
import { AccessoristoreEditComponent } from './accessoristore-edit/accessoristore-edit.component';
import { SpinnerService } from '../../../../services/spinner/spinner.service';
import { MassModifyItem } from '../../../../components/ui/mass-modify/mass-modify-item';
import { DIALOG_LARGE_CONFIG, DIALOG_MEDIUM_CONFIG } from '../../../../utils/config/modal-settings';
import { TRUE } from '../../../../utils/config/const';

@Component({
  selector: 'app-accessoristore',
  templateUrl: './accessoristore.component.html',
  styleUrls: ['./accessoristore.component.scss']
})
export class AccessoristoreComponent extends PageTemplateTable implements OnInit, OnDestroy, AfterViewInit {


  searchFilterForm: FormGroup;
  searchFilterOther = {
    searchFilterField_publishedtrue: false,
    searchFilterField_publishedfalse: false
  }

  /**
   * Configura i button della floatingbar
   */
  public menuItems: FloatingItem[] = [
    {
      title: '',
      icon: 'fas fa-upload',
      choice: 'CREATE'
    }
  ];
  public menuSettings: any;
  public menuList: any;
  public selectedMenu: any;
  public isEmpty: boolean = false;
  public isSearching: boolean = false;

  constructor(
    private storeAccessoryService: StoreAccessoryService,
    private spinner: SpinnerService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    public modalService: NgbModal
  ) {
    super(modalService);
    this.searchFilterForm = this.fb.group({
      searchOldValue: '',
      searchFilterField: ''
    });
  }


  /**
    * Inizializza la tabella
    */
  initTable() {
    const that = this;
    this.initCommon_dtOptions();
    this.dtOptions['columnDefs'] = [
      { orderable: false, targets: 0, width: '5%' },
      { orderable: false, targets: 1, width: '5%' },
      { orderable: false, targets: 2, width: '15%' },
      { orderable: false, targets: 3, width: '20%' },
      { orderable: false, targets: 4, width: '20%' },
      { orderable: false, targets: 5, width: '10%' },
      { orderable: false, targets: 6, width: '15%' }
    ];
    this.dtOptions['ajax'] = (dataTablesParameters: any, callback) => {
      this.isSearching = true;

      if (dataTablesParameters.start > 0) {
        dataTablesParameters.start = dataTablesParameters.start / this.dimPagina;
      }
      that.numeroPagina = dataTablesParameters.start;
      this.dtOptions.pageLength = this.dimPagina;
      let documentRequestSearch = that.getFilter();
      that.storeAccessoryService.search(documentRequestSearch).subscribe(
        (response) => {
          if (response != null && typeof response != typeof undefined) {
            if (response.data.length == 0) {
              this.isEmpty = true;
            } else {
              this.isEmpty = false;
            }
            that.setListEntityList(response);
            callback({
              recordsTotal: response.total,
              recordsFiltered: response.total,
              data: []
            });
          } else {
            this.isEmpty = false;
            callback({
              recordsTotal: 0,
              recordsFiltered: 0,
              data: []
            });
          }
          that.spinner.hide();
          that.isSearching = false;
        },
        (error: HttpErrorResponse) => {
          console.log(error);
          that.spinner.hide();
          that.isSearching = false;
        }
      );
    }
    this.menuList = this.lengthMenu;
    this.menuSettings = this.settings;
    this.selectedMenu = this.defaultLength;
    this.selectedMenu = [];
    this.selectedMenu.push(this.defaultLength[0]);
  }

  ngOnInit() {
    this.initTable();
  }

  ngAfterViewInit() {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  /**
   * Click sulla lente per la ricerca
   */
  clickSearch() {
    this.searchFilterForm.controls.searchOldValue.setValue(this.searchFilterForm.controls.searchFilterField.value);
    this.resetFilter();
    this.ajaxReload();
  }

  changeFilter() {
    this.searchFilterForm.controls.searchFilterField.setValue(this.searchFilterForm.controls.searchOldValue.value);
    this.resetFilter();
    this.trigger();
  }

  changeLengthPage(length) {
    let firstPage = 0;
    this.changeLength(length.value, firstPage);
    this.dtOptions.pageLength = this.dimPagina;
    this.trigger();
  }

  removeLength() {
    let firstPage = 0;
    let length = 10;
    this.selectedMenu.push({ 'value': 10 });
    this.changeLength(length, firstPage);
    this.dtOptions.pageLength = this.dimPagina;
    this.resetFilter();
    this.trigger();
  }


  /**
  * Prende i filtri
  * @returns 
  */
  getFilter() {
    let storeAccessoryResponseSearch = new StoreAccessoryRequestSearch();
    storeAccessoryResponseSearch.name = this.searchFilterForm.controls['searchFilterField'].value;
    storeAccessoryResponseSearch.pageNumber = this.numeroPagina;
    storeAccessoryResponseSearch.pageSize = this.dimPagina;
    storeAccessoryResponseSearch.sortBy = "index:asc"

    if (this.searchFilterOther.searchFilterField_publishedtrue != this.searchFilterOther.searchFilterField_publishedfalse) {
      if (this.searchFilterOther.searchFilterField_publishedtrue) {
        storeAccessoryResponseSearch.published = true;
      }
      if (this.searchFilterOther.searchFilterField_publishedfalse) {
        storeAccessoryResponseSearch.published = false;
      }
    }
    return storeAccessoryResponseSearch;
  }


  /**
 * 
 * @param id Delete document
 */
  delete(id) {
    this.storeAccessoryService.delete(id).subscribe(
      (response: any) => {
        //Aggiorna tabella
        this.ajaxReload();
        //Togli spinner
        this.spinner.hide();
        //Feedback all'utente
        this.toastr.success('Accessori cancellato con successo', 'Cancella Accessori');
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.spinner.hide();
        this.toastr.error('Si è verificato un errore durante la cancellazione del Accessori', 'Cancella Accessori fallita', {
          timeOut: 5000
        });
      }
    );
  }


  /****** */

  /*  Gestione Azioni tabella */

  clickButtonDelete(id) {
    const modalRef = this.modalService.open(ActionConfirmComponent, DIALOG_MEDIUM_CONFIG);
    modalRef.componentInstance.actionTemplate = new ActionConfirmModel();
    modalRef.componentInstance.actionTemplate.title = "Delete";
    modalRef.componentInstance.actionTemplate.body = "Sei sicuro di voler cancellare Accessori?";
    modalRef.componentInstance.actionTemplate.textButtonConfirm = "Conferma";
    modalRef.componentInstance.actionTemplate.textButtonCancel = "Annulla";
    modalRef.result.then(result => {
      if (result) {
        if (result.confirm === TRUE) {
          this.delete(id);
        }
      }
    });
  }



  clickButtonUpdate(id) {
    //Apertura modale di modifica 
    const modalRef = this.modalService.open(AccessoristoreEditComponent, DIALOG_LARGE_CONFIG);
    modalRef.componentInstance.id = id;
    modalRef.result.then((result: StoreAccessoryResponseUpdate) => {
      if (result) {
        this.ajaxReload();
      }
    });
  }



  clickButtonPublish(obj, publish) {
    this.storeAccessoryService.publish(obj.id, publish).subscribe(
      (response: StoreAccessoryResponsePublish) => {
        if (response != null && typeof response != typeof undefined) {
          obj.published = publish;
          if (publish) {
            this.toastr.success('Accessorio pubblicato con successo', 'Pubblica Accessorio', {
              timeOut: 5000
            });
          } else {
            this.toastr.success('Accessorio depubblicato con successo', 'Depubblica Accessorio', {
              timeOut: 5000
            });
          }
        }
      },
      (error) => {
        if (publish) {
          this.toastr.error('Si è verificato un errore durante la pubblicazione del Promozione/Evento', 'Pubblica Promozione/Evento fallita', {
            timeOut: 5000
          });
        } else {
          this.toastr.error('Si è verificato un errore durante la depubblicazione del Promozione/Evento', 'Depubblica documento fallita', {
            timeOut: 5000
          });
        }
      });
  }

  clickButtonClearFilter() {
    this.searchFilterForm.controls.searchFilterField.setValue('');
    this.searchFilterOther.searchFilterField_publishedtrue = false;
    this.searchFilterOther.searchFilterField_publishedfalse = false;
    this.clickSearch();
  }

  /**
   * Gestione degli eventi della floatingBar
   * @param $event  
   */
  choiceButtonResponse($event) {
    if ($event == "CREATE") {
      //Apre modale di create
      const modalRef = this.modalService.open(AccessoristoreCreateComponent, DIALOG_LARGE_CONFIG);
      modalRef.result.then(result => {
        if (result && result != "CLOSE") {
          this.ajaxReload();
        }
      });
    }
  }

  /**
   * Gestione azioni modifica di massa
   */



  /* FUNZIONI PER MODIFICHE DI MASSA */
  /**
   * Configura i button del menÃ¹ modifiche di massa
   */
  public massModifyItems: MassModifyItem[] = [
    {
      title: 'Pubblica',
      value: '',
      styleClass: 'dropdown-submenu',
      choice: [
        { title: 'Si', icon: '', styleClass: '', value: 'PUBLIC_TRUE', },
        { title: 'No', icon: '', styleClass: '', value: 'PUBLIC_FALSE', }
      ]
    },
    { styleClass: 'dropdown-divider' },
    {
      title: 'Elimina',
      styleClass: '',
      value: 'DELETE',
    },
  ];
  choiceButtonMassModifyResponse(value) {
    let isOk = this.onClickControllItemMassModify();
    if (isOk === TRUE) {
      switch (value) {
        case 'PUBLIC_TRUE': this.onClickButtonItemMassModify_public(true); break;
        case 'PUBLIC_FALSE': this.onClickButtonItemMassModify_public(false); break;
        case 'DELETE': this.onClickButtonItemMassModify_delete(); break;
      }
    }
  }
  onClickButtonItemMassModify_public(value) {
    let list = this.getListChecked();
    let massModifyObj = [];
    for (let obj of list) {
      massModifyObj.push({
        id: obj.id,
        title: obj.name,
        loading: true,
        call: () => {
          return this.storeAccessoryService.publish(obj.id, value)
        }
      });
    }
    if (list.length > 0) {
      this.openMultiLoadingView(massModifyObj);
    }
  }
  onClickButtonItemMassModify_delete() {
    const modalRef = this.modalService.open(ActionConfirmComponent, DIALOG_MEDIUM_CONFIG);
    modalRef.componentInstance.actionTemplate = new ActionConfirmModel();
    modalRef.componentInstance.actionTemplate.title = "Delete";
    modalRef.componentInstance.actionTemplate.body = "Sei sicuro di voler cancellare?";
    modalRef.componentInstance.actionTemplate.textButtonConfirm = "Conferma";
    modalRef.componentInstance.actionTemplate.textButtonCancel = "Annulla";
    modalRef.result.then(result => {
      if (result) {
        if (result.confirm === TRUE) {
          let list = this.getListChecked();
          let massModifyObj = [];
          for (let obj of list) {
            massModifyObj.push({
              id: obj.id,
              title: obj.name,
              loading: true,
              call: () => {
                return this.storeAccessoryService.delete(obj.id)
              }
            });
          }
          if (list.length > 0) {
            this.openMultiLoadingView(massModifyObj);
          }
        }
      }
    });
  }
}
